import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import { pathDitutup, menuPertama } from '@/utils/menuAkses'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard-inventory',
    children: [
      {
        path: '/dashboard-inventory',
        name: 'Dashboard Inventory',
        component: () =>
          import(
            /* webpackChunkName: "dashboard-inventory" */ '@/views/dashboard/DashboardInventory.vue'
          ),
      },
      {
        path: '/dashboard-keuangan',
        name: 'Dashboard Keuangan',
        component: () => import(/* webpackChunkName: "dashboard-keuangan" */ '@/views/dashboard/DashboardKeuangan.vue'),
      },
      {
        path: '/dashboard-kepegawaian',
        name: 'Dashboard Kepegawaian',
        component: () => import(/* webpackChunkName: "dashboard-kepegawaian" */ '@/views/dashboard/KDashboard.vue'),
      },
      {
        path: '/dashboard-publik',
        name: 'Dashboard Publik',
        component: () =>
          import(
            /* webpackChunkName: "dashboard-publik" */ '@/views/dashboard/PublicLinksView.vue'
          ),
      },
      {
        path: '/dashboard',
        name: 'Dashboard Distribusi',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard.vue'),
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/master/UsersView.vue'),
      },
      {
        path: '/cabang',
        name: 'cabang',
        component: () => import('@/views/master/MCabangView.vue'),
      },
      {
        path: '/gudang',
        name: 'gudang',
        component: () => import('@/views/master/MGudangView.vue'),
      },
      {
        path: '/lokasi',
        name: 'Lokasi Gudang',
        component: () => import('@/views/master/MLokasiView.vue'),
      },
      {
        path: '/import-saldo-awal',
        name: 'Import Saldo Awal',
        component: () => import('@/views/pergudangan/TImportSaldoAwal.vue'),
      },
      // ─── Penjualan & Pembelian (logika bersama: views/dagang) ─
      {
        path: '/penjualan/order',
        name: 'Sales Order',
        component: () => import(/* webpackChunkName: "penjualan" */ '@/views/penjualan/PSalesOrder.vue'),
      },
      {
        path: '/penjualan/faktur',
        name: 'Faktur Penjualan',
        component: () => import(/* webpackChunkName: "penjualan" */ '@/views/penjualan/PFakturPenjualan.vue'),
      },
      {
        path: '/penjualan/kwitansi',
        name: 'Kwitansi',
        component: () => import(/* webpackChunkName: "penjualan" */ '@/views/penjualan/PKwitansi.vue'),
      },
      {
        path: '/penjualan/piutang',
        name: 'Piutang',
        component: () => import(/* webpackChunkName: "penjualan" */ '@/views/penjualan/PPiutang.vue'),
      },
      {
        path: '/pembelian/order',
        name: 'Purchase Order',
        component: () => import(/* webpackChunkName: "pembelian" */ '@/views/pembelian/BPurchaseOrder.vue'),
      },
      {
        path: '/pembelian/faktur',
        name: 'Faktur Pembelian',
        component: () => import(/* webpackChunkName: "pembelian" */ '@/views/pembelian/BFakturPembelian.vue'),
      },
      {
        path: '/pembelian/hutang',
        name: 'Hutang',
        component: () => import(/* webpackChunkName: "pembelian" */ '@/views/pembelian/BHutang.vue'),
      },
      // ─── Monitoring faktur pajak (D365 vs Coretax) ─
      {
        path: '/pajak/monitoring',
        name: 'Monitoring Faktur Pajak',
        meta: { pajak: true },
        component: () => import(/* webpackChunkName: "pajak" */ '@/views/pajak/PajakMonitoring.vue'),
      },
      {
        path: '/pajak/pencocokan',
        name: 'Pencocokan Faktur Pajak',
        meta: { pajak: true, pajakPusat: true },
        component: () => import(/* webpackChunkName: "pajak" */ '@/views/pajak/PajakPencocokan.vue'),
      },
      {
        path: '/pajak/pengaturan',
        name: 'Pengaturan Faktur Pajak',
        meta: { pajak: true, pajakPusat: true },
        component: () => import(/* webpackChunkName: "pajak" */ '@/views/pajak/PajakPengaturan.vue'),
      },
      // ─── Akun saya (semua role; meta.akun boleh dibuka akun karyawan & UMKM) ──
      {
        path: '/akun/profil',
        name: 'Akun Saya',
        meta: { akun: true },
        component: () => import(/* webpackChunkName: "akun" */ '@/views/akun/AkunProfil.vue'),
      },
      // ─── Praktik Mandiri Bidan (meta.klinik: hanya akun Bidan / role 6 dan Kasir Klinik / role 7) ──
      {
        path: '/klinik/beranda',
        name: 'Beranda Klinik',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikBeranda.vue'),
      },
      {
        path: '/klinik/antrian',
        name: 'Antrian Pasien',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikAntrian.vue'),
      },
      {
        path: '/klinik/pasien',
        name: 'Data Pasien',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikPasien.vue'),
      },
      {
        path: '/klinik/periksa/:id',
        name: 'Pemeriksaan Pasien',
        meta: { klinik: true, bidan: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikPemeriksaan.vue'),
      },
      {
        path: '/klinik/jadwal',
        name: 'Jadwal & Pengingat',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikJadwal.vue'),
      },
      {
        path: '/klinik/kasir',
        name: 'Kasir Klinik',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikKasir.vue'),
      },
      {
        path: '/klinik/apotek',
        name: 'Obat & Stok',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikApotek.vue'),
      },
      {
        path: '/klinik/laporan',
        name: 'Laporan Klinik',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikLaporan.vue'),
      },
      {
        path: '/klinik/pengaturan',
        name: 'Layanan & Tarif',
        meta: { klinik: true },
        component: () => import(/* webpackChunkName: "klinik" */ '@/views/klinik/KlinikPengaturan.vue'),
      },
      // ─── Coffee shop (menu /kafe/* diaktifkan per perusahaan di Pengaturan Menu; Kasir Kafe / role 10 hanya kasir) ──
      {
        path: '/kafe/kasir',
        name: 'Kasir Kafe',
        meta: { kafe: true, kasirKafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeKasir.vue'),
      },
      {
        path: '/kafe/dashboard',
        name: 'Dashboard Kafe',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeDashboard.vue'),
      },
      {
        path: '/kafe/menu',
        name: 'Menu & Resep',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeMenu.vue'),
      },
      {
        path: '/kafe/bahan',
        name: 'Bahan Baku',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeBahan.vue'),
      },
      {
        path: '/kafe/hpp',
        name: 'HPP & Harga Jual',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeHpp.vue'),
      },
      {
        path: '/kafe/stok',
        name: 'Stok Bahan',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeStok.vue'),
      },
      {
        path: '/kafe/pembelian',
        name: 'Pembelian Bahan',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafePembelian.vue'),
      },
      {
        path: '/kafe/keuangan',
        name: 'Keuangan Kafe',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafeKeuangan.vue'),
      },
      {
        path: '/kafe/pengaturan',
        name: 'Pengaturan Kafe',
        meta: { kafe: true },
        component: () => import(/* webpackChunkName: "kafe" */ '@/views/kafe/KafePengaturan.vue'),
      },
      // ─── POS UMKM (meta.pos: satu-satunya halaman untuk akun UMKM / role 5) ──
      {
        path: '/pos/kasir',
        name: 'Kasir POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosKasir.vue'),
      },
      {
        path: '/pos/riwayat',
        name: 'Riwayat Penjualan POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosRiwayat.vue'),
      },
      {
        path: '/pos/kasbon',
        name: 'Kasbon POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosKasbon.vue'),
      },
      {
        path: '/pos/barang',
        name: 'Barang POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosBarang.vue'),
      },
      {
        path: '/pos/pengeluaran',
        name: 'Pengeluaran POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosPengeluaran.vue'),
      },
      {
        path: '/pos/laporan',
        name: 'Laporan POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosLaporan.vue'),
      },
      {
        path: '/pos/toko',
        name: 'Info Toko POS',
        meta: { pos: true },
        component: () => import(/* webpackChunkName: "pos" */ '@/views/pos/PosToko.vue'),
      },
      // ─── Kepegawaian (admin) ───────────────────────────────
      {
        path: '/kepegawaian/karyawan',
        name: 'Data Karyawan',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KDataKaryawan.vue'),
      },
      {
        path: '/kepegawaian/upload-payslip',
        name: 'Upload Payslip',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KUploadPayslip.vue'),
      },
      {
        path: '/kepegawaian/payslip',
        name: 'Payslip',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KPayslip.vue'),
      },
      {
        path: '/kepegawaian/jam-kerja',
        name: 'Jam Kerja',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KJamKerja.vue'),
      },
      {
        path: '/kepegawaian/struktur-organisasi',
        name: 'Struktur Organisasi',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KStrukturOrganisasi.vue'),
      },
      {
        path: '/kepegawaian/jenis-cuti',
        name: 'Jenis Cuti & Izin',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KJenisCuti.vue'),
      },
      {
        path: '/kepegawaian/perangkat-presensi',
        name: 'Device Presensi',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KPerangkatPresensi.vue'),
      },
      {
        path: '/kepegawaian/lokasi-presensi',
        name: 'Lokasi Presensi',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KLokasiPresensi.vue'),
      },
      {
        path: '/kepegawaian/rekap-presensi',
        name: 'Rekap Presensi',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KRekapPresensi.vue'),
      },
      {
        path: '/kepegawaian/persetujuan',
        name: 'Persetujuan ESS',
        component: () => import(/* webpackChunkName: "kepegawaian" */ '@/views/kepegawaian/KPersetujuan.vue'),
      },
      // ─── Kartu Nama Digital (data dari Data Karyawan; desain per perusahaan) ──
      {
        path: '/kartu-nama/daftar',
        name: 'Kartu Nama',
        component: () => import(/* webpackChunkName: "kartu-nama" */ '@/views/kartu-nama/KartuNamaDaftar.vue'),
      },
      {
        path: '/kartu-nama/desain',
        name: 'Desain Kartu Nama',
        component: () => import(/* webpackChunkName: "kartu-nama" */ '@/views/kartu-nama/KartuNamaDesain.vue'),
      },
      // ─── Pemilihan (menu modul; halaman pemilih & layar hasil ada di route publik) ──
      {
        path: '/pemilihan/panitia',
        name: 'Pemilihan',
        component: () => import(/* webpackChunkName: "pemilihan" */ '@/views/pemilihan/PemilihanPanitia.vue'),
      },
      {
        path: '/pengaturan-aplikasi',
        name: 'Logo & Branding',
        meta: { superadmin: true },
        component: () => import('@/views/master/MBrandingView.vue'),
      },
      {
        path: '/pengaturan-menu',
        name: 'Pengaturan Menu',
        component: () => import('@/views/master/MPengaturanMenu.vue'),
      },
      // ─── Employee Self Service (karyawan, role 4) ──────────
      {
        path: '/ess/beranda',
        name: 'Beranda',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssBeranda.vue'),
      },
      {
        path: '/ess/presensi',
        name: 'Presensi',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssPresensi.vue'),
      },
      {
        path: '/ess/profil',
        name: 'Profil Saya',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssProfil.vue'),
      },
      {
        path: '/ess/payslip',
        name: 'Payslip Saya',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssPayslip.vue'),
      },
      {
        path: '/ess/cuti',
        name: 'Cuti & Izin',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssCuti.vue'),
      },
      {
        path: '/ess/tim',
        name: 'Persetujuan Tim',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssTim.vue'),
      },
      {
        path: '/ess/kartu-nama',
        name: 'Kartu Nama Saya',
        meta: { ess: true },
        component: () => import(/* webpackChunkName: "ess" */ '@/views/ess/EssKartuNama.vue'),
      },
      // Menu Ganti Password ESS dihapus; tautan lama diarahkan ke Akun Saya (dropdown header)
      { path: '/ess/password', redirect: { path: '/akun/profil', hash: '#ganti-password' } },
      {
        path: '/perusahaan',
        name: 'Perusahaan',
        component: () => import('@/views/master/MPerusahaanView.vue'),
      },
      {
        path: '/pengaturan-perusahaan',
        name: 'Pengaturan Perusahaan',
        component: () => import('@/views/master/MPengaturanPerusahaanView.vue'),
      },
      {
        path: '/pelanggan',
        name: 'pelanggan',
        component: () => import('@/views/master/MStakeView.vue'),
      },
      {
        path: '/mitra',
        name: 'mitra',
        component: () => import('@/views/master/MMitraView.vue'),
      },
      {
        path: '/produk',
        name: 'produk',
        component: () => import('@/views/master/MProdukView.vue'),
      },
      {
        path: '/theme',
        name: 'Theme',
        redirect: '/theme/typography',
      },
      {
        path: '/theme/colors',
        name: 'Colors',
        component: () => import('@/views/theme/Colors.vue'),
      },
      {
        path: '/theme/typography',
        name: 'Typography',
        component: () => import('@/views/theme/Typography.vue'),
      },
      {
        path: '/base',
        name: 'Base',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/base/breadcrumbs',
        children: [
          {
            path: '/base/accordion',
            name: 'Accordion',
            component: () => import('@/views/base/Accordion.vue'),
          },
          {
            path: '/base/breadcrumbs',
            name: 'Breadcrumbs',
            component: () => import('@/views/base/Breadcrumbs.vue'),
          },
          {
            path: '/base/cards',
            name: 'Cards',
            component: () => import('@/views/base/Cards.vue'),
          },
          {
            path: '/base/carousels',
            name: 'Carousels',
            component: () => import('@/views/base/Carousels.vue'),
          },
          {
            path: '/base/collapses',
            name: 'Collapses',
            component: () => import('@/views/base/Collapses.vue'),
          },
          {
            path: '/base/list-groups',
            name: 'List Groups',
            component: () => import('@/views/base/ListGroups.vue'),
          },
          {
            path: '/base/navs',
            name: 'Navs',
            component: () => import('@/views/base/Navs.vue'),
          },
          {
            path: '/base/paginations',
            name: 'Paginations',
            component: () => import('@/views/base/Paginations.vue'),
          },
          {
            path: '/base/placeholders',
            name: 'Placeholders',
            component: () => import('@/views/base/Placeholders.vue'),
          },
          {
            path: '/base/popovers',
            name: 'Popovers',
            component: () => import('@/views/base/Popovers.vue'),
          },
          {
            path: '/base/progress',
            name: 'Progress',
            component: () => import('@/views/base/Progress.vue'),
          },
          {
            path: '/base/spinners',
            name: 'Spinners',
            component: () => import('@/views/base/Spinners.vue'),
          },
          {
            path: '/base/tables',
            name: 'Tables',
            component: () => import('@/views/base/Tables.vue'),
          },
          {
            path: '/base/tooltips',
            name: 'Tooltips',
            component: () => import('@/views/base/Tooltips.vue'),
          },
        ],
      },
      {
        path: '/buttons',
        // name: 'Buttons',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/buttons/standard-buttons',
        children: [
          {
            path: '/buttons/standard-buttons',
            name: 'Buttons',
            component: () => import('@/views/buttons/Buttons.vue'),
          },
          {
            path: '/buttons/dropdowns',
            name: 'Dropdowns',
            component: () => import('@/views/buttons/Dropdowns.vue'),
          },
          {
            path: '/buttons/button-groups',
            name: 'Button Groups',
            component: () => import('@/views/buttons/ButtonGroups.vue'),
          },
        ],
      },
      {
        path: '/forms',
        name: 'Forms',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/forms/form-control',
        children: [
          {
            path: '/forms/form-control',
            name: 'Form Control',
            component: () => import('@/views/forms/FormControl.vue'),
          },
          {
            path: '/forms/select',
            name: 'Select',
            component: () => import('@/views/forms/Select.vue'),
          },
          {
            path: '/forms/checks-radios',
            name: 'Checks & Radios',
            component: () => import('@/views/forms/ChecksRadios.vue'),
          },
          {
            path: '/forms/range',
            name: 'Range',
            component: () => import('@/views/forms/Range.vue'),
          },
          {
            path: '/forms/input-group',
            name: 'Input Group',
            component: () => import('@/views/forms/InputGroup.vue'),
          },
          {
            path: '/forms/floating-labels',
            name: 'Floating Labels',
            component: () => import('@/views/forms/FloatingLabels.vue'),
          },
          {
            path: '/forms/layout',
            name: 'Layout',
            component: () => import('@/views/forms/Layout.vue'),
          },
          {
            path: '/forms/validation',
            name: 'Validation',
            component: () => import('@/views/forms/Validation.vue'),
          },
        ],
      },
      {
        path: '/upload',
        name: 'Upload',
        component: () => import('@/views/pengiriman/TUploadPengirimanView.vue'),
      },
      {
        path: '/pengiriman',
        name: 'Pengiriman',
        component: () => import('@/views/pengiriman/TPengirimanView.vue'),
      },
      {
        path: '/updatepengiriman',
        name: 'Update Pengiriman',
        component: () => import('@/views/pengiriman/TUpdatePengirmanView.vue'),
      },
      {
        path: '/trace',
        name: 'Tracking',
        component: () => import('@/views/pengiriman/TTrackingView.vue'),
      },
      {
        path: '/report',
        name: 'Report',
        component: () => import('@/views/pengiriman/ReportView.vue'),
      },
      {
        // Halaman lama (views/paper), bukan modul Penjualan. Nama route harus unik:
        // nama yang sama dengan route lain membuat vue-router membuang salah satunya.
        path: '/salesorder/',
        name: 'Sales Order (lama)',
        component: () => import('@/views/paper/TSalesOrder.vue'),
      },
      {
        path: '/order-barang/',
        name: 'Order Barang',
        component: () => import('@/views/pergudangan/TOrderBarang.vue'),
      },
      {
        path: '/pergerakan-stok/',
        name: 'Pergerakan Stok',
        component: () => import('@/views/pergudangan/TPergerakanStok.vue'),
      },
      {
        path: '/audit-stok/',
        name: 'Audit Stok',
        component: () => import('@/views/pergudangan/TAuditStok.vue'),
      },
      {
        path: '/sewa/kontrak',
        name: 'Kontrak Sewa',
        component: () => import('@/views/sewa/TRentalContract.vue'),
      },
      {
        path: '/sewa/invoice',
        name: 'Invoice Sewa',
        component: () => import('@/views/sewa/TInvoiceView.vue'),
      },
      {
        path: '/laporan/stok-barang',
        name: 'Laporan Stok Barang',
        component: () => import('@/views/laporan/LStokBarang.vue'),
      },
      {
        path: '/laporan/mutasi-stok',
        name: 'Laporan Mutasi Stok',
        component: () => import('@/views/laporan/LMutasiStok.vue'),
      },
      {
        path: '/laporan/order-barang',
        name: 'Laporan Order Barang',
        component: () => import('@/views/laporan/LOrderBarang.vue'),
      },
      {
        path: '/laporan/audit-stok',
        name: 'Laporan Audit Stok',
        component: () => import('@/views/laporan/LAuditStok.vue'),
      },
      {
        path: '/icons',
        name: 'Icons',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/icons/coreui-icons',
        children: [
          {
            path: '/icons/coreui-icons',
            name: 'CoreUI Icons',
            component: () => import('@/views/icons/CoreUIIcons.vue'),
          },
          {
            path: '/icons/brands',
            name: 'Brands',
            component: () => import('@/views/icons/Brands.vue'),
          },
          {
            path: '/icons/flags',
            name: 'Flags',
            component: () => import('@/views/icons/Flags.vue'),
          },
        ],
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/notifications/alerts',
        children: [
          {
            path: '/notifications/alerts',
            name: 'Alerts',
            component: () => import('@/views/notifications/Alerts.vue'),
          },
          {
            path: '/notifications/badges',
            name: 'Badges',
            component: () => import('@/views/notifications/Badges.vue'),
          },
          {
            path: '/notifications/modals',
            name: 'Modals',
            component: () => import('@/views/notifications/Modals.vue'),
          },
        ],
      },
      {
        path: '/widgets',
        name: 'Widgets',
        component: () => import('@/views/widgets/Widgets.vue'),
      },
    ],
  },
  {
    // Tujuan QR code di payslip: cek keaslian tanpa login
    path: '/public/payslip/:kode',
    name: 'Verifikasi Payslip',
    meta: { public: true },
    component: () => import(/* webpackChunkName: "public-payslip" */ '@/views/kepegawaian/PublicVerifikasiPayslip.vue'),
  },
  {
    // Tujuan QR code kartu nama digital: tampil tanpa login (link pendek agar QR tidak padat)
    path: '/k/:kode',
    name: 'Kartu Nama Publik',
    meta: { public: true },
    component: () => import(/* webpackChunkName: "public-kartu-nama" */ '@/views/kartu-nama/PublicKartuNama.vue'),
  },
  {
    // Pemilih memberikan suara tanpa login: tulis kode, atau scan QR undangan (#/pilih/<kode>)
    path: '/pilih/:kode?',
    name: 'Halaman Pemilih',
    meta: { public: true },
    component: () => import(/* webpackChunkName: "public-pemilihan" */ '@/views/pemilihan/PublicPilih.vue'),
  },
  {
    // Layar perolehan suara, akses lewat token tanpa login
    path: '/hasil-pemilihan/:token',
    name: 'Hasil Pemilihan',
    meta: { public: true },
    component: () => import(/* webpackChunkName: "public-pemilihan" */ '@/views/pemilihan/PublicHasilPemilihan.vue'),
  },
  {
    // Dashboard Inventory publik, akses lewat token tanpa login
    path: '/public/inventory/:token',
    name: 'Public Inventory',
    meta: { public: true },
    component: () =>
      import(
        /* webpackChunkName: "public-inventory" */ '@/views/dashboard/PublicDashboardInventory.vue'
      ),
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  // Login dianggap sah hanya bila ada token sesi dari API
  const isLogin = JSON.parse(localStorage.getItem('authenticated')) && !!localStorage.getItem('auth_token')
  const role = localStorage.getItem('role_id')
  const klinik = role === '6' || role === '7'
  const pajak = role === '8' || role === '9'
  const beranda = role === '4' ? '/ess/beranda' : role === '5' ? '/pos/kasir' : klinik ? '/klinik/beranda' : pajak ? '/pajak/monitoring' : role === '10' ? '/kafe/kasir' : '/dashboard-inventory'
  if (to.meta.public) next()
  else if (to.name !== 'Login' && !isLogin) next({ name: 'Login' })
  else if (to.name === 'Login' && isLogin) next(beranda)
  // Karyawan hanya ESS; admin tidak membuka halaman ESS
  else if (role === '4' && !to.meta.ess && !to.meta.akun && to.name !== 'Login') next(beranda)
  else if (role !== '4' && to.meta.ess) next(beranda)
  // Akun UMKM hanya kasir POS
  else if (role === '5' && !to.meta.pos && !to.meta.akun && to.name !== 'Login') next(beranda)
  // Akun praktik bidan hanya menu klinik; rekam medis hanya bidan; akun lain tidak membuka data pasien
  else if (klinik && !to.meta.klinik && !to.meta.akun && to.name !== 'Login') next(beranda)
  else if (!klinik && to.meta.klinik) next(beranda)
  else if (to.meta.bidan && role !== '6') next(from.name ? false : beranda)
  // Akun pajak hanya modul pajak; modul pajak hanya untuk akun pajak (+ superadmin); Pajak Cabang hanya Monitoring
  else if (pajak && !to.meta.pajak && !to.meta.akun && to.name !== 'Login') next(beranda)
  else if (!pajak && role !== '1' && to.meta.pajak) next(beranda)
  else if (to.meta.pajakPusat && role === '9') next(from.name ? false : beranda)
  // Kasir Kafe hanya layar kasir; modul kafe untuk admin perusahaan (diatur Pengaturan Menu) dan superadmin
  else if (role === '10' && !to.meta.kasirKafe && !to.meta.akun && to.name !== 'Login') next(beranda)
  else if (to.meta.kafe && !['1', '2', '3', '10'].includes(role)) next(beranda)
  // Menu yang dimatikan untuk perusahaan ini (Pengaturan Menu)
  else if (to.meta.superadmin && role !== '1') next(beranda)
  else if (pathDitutup(to.path, role)) {
    // Beranda sendiri ditutup: ke menu pertama yang terbuka, agar tidak berputar ke beranda terus
    if (to.path === beranda) next(menuPertama(role) || undefined)
    else next(from.name ? false : beranda)
  } else next()
})

// Setelah deploy, file halaman versi lama sudah tidak ada di server. Muat ulang sekali untuk mengambil versi terbaru.
router.onError((err, to) => {
  if (!/Loading (CSS )?chunk/i.test(err.message)) return
  if (sessionStorage.getItem('muat_ulang_chunk') === to.fullPath) return
  sessionStorage.setItem('muat_ulang_chunk', to.fullPath)
  window.location.hash = to.fullPath
  window.location.reload()
})
router.afterEach(() => sessionStorage.removeItem('muat_ulang_chunk'))

export default router
